import axios from '../axiosConfig';
import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;

console.log('base url from products.js', baseURL);

const fetchProductCategories = async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  const authToken = localStorage.getItem('access_token');
  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }
  try {
    const response = await axios.get('/product/category/list', { headers });
    return response;
  } catch (error) {
    return null;
  }
};

const fetchProductDetail = async (productId) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }
  try {
    const response = await axios.get(`/product/get/${productId}`, { headers });
    return response;  // Ensure returning the correct nested data
  } catch (error) {
    console.error('Error fetching product details:', error);
    return null;
  }
};


const fetchProducts = async (param) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  const authToken = localStorage.getItem('access_token');
  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }
  try { 
    const response = await axios.get('/product/list', {
      params: param,
      headers
    });
    console.log('fetchProducts response', response);
    return response;
  } catch (error) {
    return null;
  }
};

const fetchProductImg = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }
  console.log('fetchProductImg req data', data);
  
  try {
    const response = await axios.get(`/file/product/image/list?product_id=${data}`, { headers });
    console.log(response);
    return response;
  } catch (error) {
    console.error('Error fetching protected content:', error);
    return null;
  }
};

const postProduct = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }
    try {
      const response = await axios.post('/product/add', data, { headers });
      console.log('response from backend', response);
      return response;
    } catch (error) {
      return error;
    }
  };


  const updateProduct = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
      try {
        const response = await axios.put(`/product/edit/${data.id}`, data, { headers });
        // console.log(response);
        return response.data;
      } catch (error) {
        return error;
      }
    };
 
      const fetchReviews = async (product_id) => {
        var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
        if (! axios.defaults.headers.common["Authorization"]){
          headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
        }
        try {
          const response = await axios.get(`/review/list/${product_id}`, { headers });
          // console.log(response);
          return response;
        } catch (error) {
          console.error('Error fetching reviews content:', error);
          return null;
        }
      };

      const delProductImg = async (filename) => {
        var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
        if (! axios.defaults.headers.common["Authorization"]){
          headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
        }
        try {
          const response = await axios.delete(`/product/image/delete/${filename}`, { headers });
          // console.log(response);
          return response;
        } catch (error) {
          console.error('Error deleting protected content:', error);
          return null;
        }
      };
   
export { fetchProducts, fetchProductDetail, fetchProductImg, postProduct, updateProduct, fetchReviews, delProductImg, fetchProductCategories, baseURL };